import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Logo from "../asstes/logo.png";
import UserImg from "../asstes/user.png";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  // console.log("user loggedin >>", user.isLoggedin);

  //handleLogout
  const handleLogout = () => {
    localStorage.removeItem("hashUser");
    dispatch({
      type: "USER_LOGOUT",
      payload: null,
    });
  };
  return (
    <div className="header">
      <div className="container relative">
        <div className={"flex flex-row justify-between"}>
          <Link to="/" className="logo">
            <img src={Logo} alt="Hashfinder" className="logo_image" />
          </Link>
          <div className={"navigation"}>
            <ul className={"lg:flex lg:flex-row"}>
              {user?.isLoggedin ? (
                <li>
                  <div className="user_info" onClick={() => setIsOpen(!isOpen)}>
                    <div className="user_img">
                      {!user?.user?.profile_picture ? (
                        <img
                          src={UserImg}
                          alt={user?.user?.name}
                          className="user_image"
                        />
                      ) : (
                        <img
                          src={user?.user?.profile_picture}
                          alt={user?.user?.name}
                          className="user_image"
                        />
                      )}
                    </div>
                    <div className="user_content">
                      <h5>
                        {user?.user?.name}{" "}
                        <i className="ri-arrow-down-s-fill"></i>
                      </h5>
                    </div>
                    {isOpen && (
                      <div className="user_Links_wrapper">
                        <Link
                          to={"/profile"}
                          className="user_link"
                          onClick={() => setIsOpen(false)}
                        >
                          <i className="ri-user-line"></i>{" "}
                          <span className="label">Profile</span>
                        </Link>
                        <div
                          className="user_link text-red-500 cursor-pointer"
                          onClick={() => handleLogout()}
                        >
                          <i className="ri-logout-circle-r-line"></i>{" "}
                          <span className="label text-red-500">Logout</span>
                        </div>
                      </div>
                    )}
                  </div>
                </li>
              ) : (
                <li>
                  <Link to={"/login"}>Login</Link>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
